import { CALL_API } from '../../../common/middleware/api';

export const MELILLO_FORMS_ANALYTICS_REQUEST = 'MELILLO_FORMS_ANALYTICS_REQUEST';
export const MELILLO_FORMS_ANALYTICS_SUCCESS = 'MELILLO_FORMS_ANALYTICS_SUCCESS';
export const MELILLO_FORMS_ANALYTICS_FAILURE = 'MELILLO_FORMS_ANALYTICS_FAILURE';

export const loadFormsAnalyticsData = (item, options) => ({
	[CALL_API]: {
		types: [MELILLO_FORMS_ANALYTICS_REQUEST, MELILLO_FORMS_ANALYTICS_SUCCESS, MELILLO_FORMS_ANALYTICS_FAILURE],
		endpoint: `api/integrations/melillo/analytics/forms/${item}`,
		method: 'POST',
		request: options
	},
	item
});